import React, {Component} from 'react'
import PropTypes from "prop-types";

export default class DataGridFooter extends Component {

    static propTypes = {
        /**
         *  Component inner (can be anything, but recommended: DataGridRow component)
         */
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]).isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {children, ...rest} = this.props;
        return (
            <tfoot {...rest}>
                {children}
            </tfoot>
        )

    }
}
